import './App.css';
import { CollapsedProvider } from "./Context/CollapsedContext";
import Router from "./Routes/index";
import React, { useEffect } from "react";
import { BrowserRouter, useNavigate, useLocation, Navigate } from "react-router-dom";
import { checkTokenValidity } from "./Service/API";



const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    return <Navigate to="/" replace />; // 토큰이 없으면 로그인 페이지로 이동
  }
  return children; // 토큰이 있으면 정상적으로 컴포넌트를 렌더링
};

const AppContent = () => {
  const navigate = useNavigate();
  const location = useLocation(); // 현재 경로를 가져오기

   useEffect(() => {
    // Meta 태그 추가 로직
    const setViewportMeta = () => {
      const metaTag = document.createElement("meta");
      metaTag.name = "viewport";
      metaTag.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
      document.head.appendChild(metaTag);
    };

    setViewportMeta(); // 컴포넌트 마운트 시 실행

    const verifyToken = async () => {
      const token = localStorage.getItem("authToken");

      if (!token) {
        navigate("/"); // 토큰이 없으면 로그인 페이지로 이동
        return;
      }

      const isValid = await checkTokenValidity(token); // 서버로 유효성 확인
      if (!isValid) {
        localStorage.removeItem("authToken"); // 유효하지 않은 토큰 삭제
        navigate("/"); // 로그인 페이지로 이동
      } else if (location.pathname === "/") {
        navigate("/HOME");
      }
    };

    verifyToken();
  }, [navigate, location.pathname]);


  useEffect(() => {
    // 두 손가락 확대 방지
    const preventZoom = (e) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };

    document.addEventListener("touchstart", preventZoom, { passive: false });
    document.addEventListener("gesturestart", (e) => e.preventDefault()); // 제스처 확대 방지

    return () => {
      document.removeEventListener("touchstart", preventZoom);
      document.removeEventListener("gesturestart", (e) => e.preventDefault());
    };
  }, []); 

  return (
    <CollapsedProvider>
      <Router />
    </CollapsedProvider>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
